import React from 'react'
import { Box } from '@workwhile/ui'
import { DayforceBookingsHeader } from './DayforceBookingsHeader'
import { DayforceBookingsFilterBar } from './DayforceBookingsFilterBar'
import { DayforceBookingsTable } from './DayforceBookingsTable'

export const DayforceBookingsMain = () => {
  return (
    <>
      <DayforceBookingsHeader />
      <DayforceBookingsFilterBar />
      <Box margin={3}>
        <DayforceBookingsTable />
      </Box>
    </>
  )
}
